import React from "react";
import {QuestionItem as Question} from "../../common/webapicall";
import QuestionItem from "./question.item";

interface Props {
	questions: Question[];
}

const QuestionList: React.FC<Props> = ({questions}: Props) => {
	return (
		<div className="cih-questionnaire">
			{questions.map((question, i) => (
				<QuestionItem question={question} questionNumber={++i} key={question.questionId} />
			))}
		</div>
	);
};

export default QuestionList;
